import React from "react";
import { defineMessages, useIntl } from "react-intl";
import "../../../chip/ChipRenderer.js";
import { ChipType } from "../../../chip/types.js";
import { Chip, ChipWithTooltip } from "../../../chip/Chips.js";
import { ListWithChipTooltip } from "../../../chip/ListWithChipTooltip.js";
import "../../../chip/SquaredChipList.js";
import "@mui/material";
import "../../../icons/Icon.js";
import "../../../icons/ExpandMoreIcon.js";
import { withEmptyCheck } from "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
function LabelsCellInner({ value }) {
  const { formatMessage } = useIntl();
  const visibleLabelTooltip = formatMessage(labelCellLocalized.visibleLabelTooltip, {
    label: value.visibleLabel?.name,
    group: value.visibleLabel?.group?.name
  });
  return /* @__PURE__ */ React.createElement(
    ListWithChipTooltip,
    {
      visibleElement: /* @__PURE__ */ React.createElement(
        ChipWithTooltip,
        {
          key: value.visibleLabel.id,
          label: value.visibleLabel.name,
          chipType: ChipType.Status,
          chipVariant: value.visibleLabel.group?.color,
          fillWidth: false,
          title: visibleLabelTooltip,
          hideTooltip: false
        }
      ),
      hiddenElements: value.hiddenLabels?.map((label) => /* @__PURE__ */ React.createElement(Chip, { key: label.id, label: label.name, chipType: ChipType.Status, chipVariant: label.group?.color, fillWidth: false }))
    }
  );
}
const LabelsCell = withEmptyCheck(LabelsCellInner);
const renderLabelsCell = (params) => {
  const value = params.value;
  return /* @__PURE__ */ React.createElement(LabelsCell, { value });
};
const labelCellLocalized = defineMessages({
  labels: {
    id: "DefaultLabelColumn_headerName",
    defaultMessage: "Label"
  },
  visibleLabelTooltip: {
    id: "DefaultLabelColumn_visibleLabelTooltip",
    defaultMessage: "Label {label} of {group}"
  }
});
const labelCellValueGetter = (value) => {
  if (!value || value.length === 0) {
    return null;
  }
  const [visibleLabel, hiddenLabels] = [value[0], value.slice(1)];
  return {
    visibleLabel,
    hiddenLabels
  };
};
export {
  labelCellLocalized,
  labelCellValueGetter,
  renderLabelsCell
};
//# sourceMappingURL=LabelsCell.js.map
